/** @format */

import { MyCustomizations, MyCustomizerMap } from './customizations.interface';
import { PersonalizationData, PersonalizationState } from './personalization-data.interface';
import { SkuDefiningAttribute } from './sku-defining-attribute.interface';
import { NestDefiningAttribute } from './nest-defining-attribute.interface';
import { HeaderStoreSelection } from './header-location.interface';
import { Warranty } from './warranty.interface';

export interface IATC {
  ATCOriginated: string;
  cartAdditionSource?: string;
  customizationData?: MyCustomizations;
  isBopis?: boolean;
  isBopl?: boolean;
  isClearance?: boolean;
  isCustomizable: boolean;
  isProductAddOn: boolean;
  isSameDayDelivery?: boolean;
  personalizationData?: PersonalizationData;
  productEcode: string;
  productTitle: string;
  quantity: number;
  skuCatentryId: string | number;
  skuDefAttributes?: SkuDefiningAttribute[] | NestDefiningAttribute[];
  skuId: string;
  skuListPrice: number;
  skuOfferPrice: number;
  zipCode?: number | string;
}

export interface AddToCartParams {
  userInputQuantity: number;
  fulfillmentOption: string;
  storeInfo: HeaderStoreSelection;
  zipCode: string;
  customizationData: MyCustomizerMap;
  selectedPersonalizationOptions: PersonalizationState;
  resolvedSkuPartNumber: string;
  selectedWarrantyDetails: Warranty | undefined;
}
